import { render } from "./NavigationSpacer.vue?vue&type=template&id=c360773c&scoped=true"
import script from "./NavigationSpacer.vue?vue&type=script&lang=js"
export * from "./NavigationSpacer.vue?vue&type=script&lang=js"

import "./NavigationSpacer.vue?vue&type=style&index=0&id=c360773c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c360773c"]])

export default __exports__